import '@preact/signals';
import { render } from 'preact';
import { App } from './app';
import { UiContext, type UiDeps } from './context';

export function mountUi(root: HTMLElement, deps: UiDeps): void {
  render(
    <UiContext.Provider value={deps}>
      <App />
    </UiContext.Provider>,
    root,
  );
}
